import { I18nMessages } from "@/interfaces/i18n-messages";

const messages: I18nMessages = {
  en: {
    auth: {
      loginInputPlaceholder: "login",
      passwordInputPlaceholder: "password",
      logInButtonText: "log in"
    },
    navbar: {
      button: {
        logOutText: "log out"
      },
      anchor: {
        aboutUs: {
          text: "about us",
          aboutCompanyText: "about company",
          presentationText: "presentation",
          qualityText: "quality"
        },
        news: {
          text: "news",
          technicalInfoText: "technical informations",
          privacyNoticeImprintText: "privacy notice / imprint",
          onlineRegulationsText: "on-line regulations"
        },
        newItemsText: "new items",
        catalogueText: "catalogue",
        promotionsText: "promotions",
        support: {
          text: "support",
          complaintFormText: "claim form",
          promotionalMaterialsText: "promotional materials",
          faqText: "FAQ"
        },
        contactText: "contact",
        shopText: "shop"
      },
      banner: {
        logOutButtonText: "log out",
        supportAnswerTimeText: "we respond to all questions in",
        supportTimeText:
          "we offer support for our clients\n" +
          "from Monday to Friday from 8:30AM till 4:30PM",
        companyAddressHeaderText: "our company address",
        mailSupportHeaderText: "any questions?",
        phoneSupportHeaderText: "call us",
        technicalSupportHeaderText: "technical support",
        loggedInSessionStatusText: "logged in"
      }
    },
    shared: {
      toast: {
        noFalconSessionText:
          "you haven't access to Falcon services.\n" +
          "Please contact DAVID Vasco for further assistance",
        expiredPaymentsText: "there are overdue payments in the system"
      },
      httpError: {
        unauthorizedText: "invalid credentials",
        uncategorizedText: "request error occurred"
      },
      filterOptionsForm: {
        headerText: "filter results",
        dateFrom: {
          labelText: "start date",
          placeholder: "from"
        },
        dateTo: {
          labelText: "end date",
          placeholder: "to"
        }
      },
      sortOptionsForm: {
        headerText: "sort results",
        sortTypeText: "sort type",
        sortDirection: {
          labelText: "sort direction",
          ascendingOptionValue: "ascending",
          descendingOptionValue: "descending"
        }
      },
      paginationOptionsForm: {
        headerText: "pagination",
        pageSizeLabelText: "results per page"
      },
      filters: {
        booleanText: {
          yesText: "yes",
          noText: "no"
        },
        documentType: {
          invoiceText: "invoice",
          assignationText: "assignation",
          invoiceCorrectionText: "invoice correction"
        },
        paymentStatus: {
          unsettledText: "unsettled",
          settledText: "settled"
        },
        documentsPaymentType: {
          noneText: "none",
          cashText: "cash",
          terminalCashText: "terminal cash",
          checkText: "check",
          transferText: "transfer",
          cashAndTransferText: "cash/transfer",
          cashOnDeliveryText: "cash on delivery",
          creditCardText: "credit card",
          installmentsText: "installments"
        },
        documentsPaymentStatus: {
          allText: "unknown",
          settledText: "settled",
          unsettledText: "unsettled",
          unsettledExpiredText: "unsettled - expired"
        },
        complaintDecisionType: {
          noneText: "none",
          positiveText: "positive",
          negativeText: "negative"
        },
        complaintState: {
          closedText: "closed",
          openText: "open",
          terminalText: "terminal"
        },
        complaintPositiveDecision: {
          refundText: "refund",
          exchangeText: "exchange"
        },
        complaintNegativeDecision: {
          scrappingText: "scrapping",
          returnText: "return"
        },
        complaintFaultMoment: {
          beforeAssemblyText: "before assembly",
          duringAssemblyText: "during assembly",
          duringUseText: "during use",
          afterCollisionText: "after collision"
        },
        complaintFaultEntity: {
          workshopText: "workshop",
          userText: "user"
        }
      },
      formActionButtonText: "display results"
    },
    payments: {
      moduleTitleText: "payments",
      filterOptionsForm: {
        headerText: "filter payments",
        paymentStatus: {
          labelText: "status",
          unsettledOptionValue: "unsettled",
          settledOptionValue: "settled"
        }
      },
      sortOptionsForm: {
        headerText: "sort payments",
        sortType: {
          createDateOptionValue: "by issue date",
          paymentDateOptionValue: "by payment date"
        }
      },
      tableColumn: {
        number: "number",
        type: "type",
        documentDate: "document date",
        gross: "gross",
        paymentDate: "payment date",
        daysLeft: "days left",
        status: "status",
        amountRemaining: "remaining amount"
      }
    },
    documents: {
      moduleTitle: {
        text: "documents",
        detailsText: "document {documentId} details",
        selectComplaintDocumentText: "make a complaint"
      },
      moduleSubTitle: {
        complaintCreationInfoText: "select document, then product"
      },
      complaintCreationGuide: {
        firstStep: {
          beforeIconText: "select the document",
          afterIconText:
            "on which the claimed product is located, " +
            "use the available document filtering options"
        },
        secondStepText: "find the claimed product on the document",
        thirdStep: {
          beforeIconText: "click the red icon",
          afterIconText: "next to the claimed product"
        },
        fourthStepText:
          "try to complete all the fields to allow us fast claim handling"
      },
      filterOptionsForm: {
        headerText: "filter documents",
        documentsType: {
          labelText: "documents type",
          assignationsOptionValue: "assignations",
          invoicesOptionValue: "invoices",
          invoicesAndAssignationsOptionValue: "invoices and assignations",
          invoiceCorrectionsOptionValue: "invoice corrections"
        }
      },
      sortOptionsForm: {
        headerText: "sort documents",
        sortTypeCreateDateOptionValue: "by issue date"
      },
      tableColumn: {
        functions: "document preview",
        number: "number",
        type: "type",
        documentDate: "document date",
        net: "net",
        gross: "gross",
        paymentType: "payment type",
        paymentDateDays: "payment date (days)"
      },
      tableRowFunctionTitle: {
        documentDetails: "document details",
        downloadSpecification: "download specification",
        makeComplaint: "make a complaint about the product"
      },
      details: {
        headerText: "document {documentId} details",
        tableColumn: {
          ordinalNumber: "no.",
          productSymbol: "reference",
          productName: "product name",
          quantity: "quantity",
          unitOfMeasure: "UoM.",
          priceNet: "price net",
          priceGross: "price gross",
          taxValue: "VAT(%)",
          valueGross: "net value"
        }
      }
    },
    complaints: {
      moduleTitle: {
        text: "complaints",
        formViewText: "complaint form",
        detailsText: "complaint form - details",
        vehicleDetailsText: "complaint form - vehicle details",
        faultDescriptionText: "complaint form - fault description",
        summaryText: "complaint form - summary"
      },
      filterOptionsForm: {
        headerText: "filter complaints",
        complaintState: {
          labelText: "complaint state",
          closedOptionValue: "closed",
          openOptionValue: "open",
          terminalOptionValue: "terminal"
        }
      },
      sortOptionsForm: {
        headerText: "sort complaints",
        sortTypeCreateDateOptionValue: "by issue date"
      },
      tableColumn: {
        number: "number",
        productSymbol: "reference",
        quantity: "quantity",
        decisionType: "decision type",
        createDate: "create date",
        closeDate: "close date",
        state: "complaint state"
      },
      creationForm: {
        navigationStepButton: {
          nextText: "next step",
          previousText: "go back",
          summaryText: "summary"
        },
        details: {
          headerText: "complaint details",
          dateProductDeliveryLabelText: "product delivery date",
          serialNumberLabelText: "product serial number - if known",
          quantityLabelText: "product quantity",
          decisionPositiveLabelText: "positive decision",
          decisionNegativeLabelText: "negative decision",
          faultDetectionMomentLabelText: "moment of finding the defect",
          faultFoundByLabelText: "who found the fault?",
          refuseAddCostsLabelText: "i order collection by courier",
          compensationValueLabelText: "amount of expected compensation",
          compensationCurrencyLabelText: "currency of compensation"
        },
        vehicleDetails: {
          header: {
            text: "vehicle data",
            vehicleText: "vehicle details",
            installationText: "product assembly details",
            uninstallationText: "product disassembly details"
          },
          registerNumberLabelText: "registration number",
          engineNumberLabelText: "engine number",
          vinNumberLabelText: "VIN number - if known",
          brandVehicleLabelText: "vehicle brand",
          productionYearLabelText: "year of vehicle production",
          engineCapacityLabelText: "engine capacity",
          powerValueLabelText: "vehicle power",
          powerUnitLabelText: "vehicle power unit",
          workshopInstallNameLabelText: "workshop name",
          workshopInstallAddressLabelText: "workshop address",
          installedByLabelText: "who assembled the product?",
          counterStateInstallLabelText: "meter reading on the day of assembly",
          installationDateLabelText: "assembly date",
          workshopUninstallNameLabelText: "workshop name",
          workshopUninstallAddressLabelText: "workshop address",
          uninstalledByLabelText: "who disassembled the product?",
          counterStateUninstallLabelText:
            "meter reading on the day of disassembly",
          uninstallationDateLabelText: "disassembly date"
        },
        faultDescription: {
          headerText: "fault description",
          labelText: "exact fault description of the chosen product"
        },
        summary: {
          newComplaint: {
            alert: {
              headerText: "attention",
              text:
                "a new complaint will be created when button below is clicked"
            },
            buttonText: "make a complaint"
          }
        }
      }
    }
  }
};
export default messages;
